.eds-modal--overlay {
  background: rgb(from var(--eds--color--bg-inverse) r g b / 0.6);
  inset: 0;
  position: fixed;
  z-index: var(--eds--z-index-modal);
}

/* Every dialog measurement lives in this one table: consumers choose a size,
   never a width, so the scale stays EDS's to retune. */
.eds-modal {
  --_modal-full-page-inset: var(--eds--spacing-16);
  --_modal-l-height: 80%;
  --_modal-l-width: 80%;
  --_modal-m-max-height: calc(100% - var(--eds--size-48));
  --_modal-m-width: 640px;
}

.eds-modal > .eds-card {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.eds-modal--size-m > .eds-card {
  max-height: var(--_modal-m-max-height);
  width: var(--_modal-m-width);
}

/* A working surface — roomy enough for a document beside a panel, while the
   page it opened over stays visible around it. */
.eds-modal--size-l > .eds-card {
  height: var(--_modal-l-height);
  width: var(--_modal-l-width);
}

.eds-modal--size-full-page > .eds-card {
  height: calc(100% - var(--_modal-full-page-inset));
  width: calc(100% - var(--_modal-full-page-inset));
}
